import { useLocation, useNavigate } from "react-router-dom";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import React, { useState, useEffect } from "react";
import swal from "sweetalert";
import { getUserList } from "../../../redux/invoice/action";
import ReactSelect from "react-select";
import { showToast } from "../../Common/Utils/Toaster";
import TestingAccountFilter from "../../Common/TestingAccountFilter";

export default function InvoiceFilters({
  modal,
  setModal,
  params,
  setParams,
  invoiceType,
}) {
  const location = useLocation();
  const dispatch = useDispatch();
  const userList = useSelector((state) => state?.reusableSlice?.userList);

  const [selectedOptions, setSelectedOptions] = useState(() => {
    if (params.user_id) {
      const user = userList?.users?.find(
        (user) => user.id === Number(params.user_id)
      );
      return user
        ? {
            value: user.id,
            label: user.full_name,
          }
        : null;
    }
    return null;
  });

  useEffect(() => {
    location.pathname === "/creditnoteslists" &&
      setParams((prevParams) => ({
        ...prevParams,
        invoice_type: 3,
      }));
    location.pathname === "/debitnoteslists" &&
      setParams((prevParams) => ({
        ...prevParams,
        invoice_type: 4,
      }));
  }, [location.pathname]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === "start_date" && params.end_date && value > params.end_date) {
      showToast("Start date cannot be greater than End date.", "error");
      return;
    }

    setParams((prevParams) => ({
      ...prevParams,
      [name]: value,
      page: 1,
    }));
  };

  const handleChange = (selected) => {
    setSelectedOptions(selected);
    setParams((prevParams) => ({
      ...prevParams,
      user_id: selected?.value || "",
      page: 1,
    }));
  };

  const proOptions = userList?.users?.map((item) => ({
    value: item?.id,
    label: item?.company_name,
  }));

  const handleApplyFilter = () => {
    setModal(false);
  };

  const handleClearFilters = () => {
    setParams({
      page: 1,
      type: 1,
      search_key: "",
      status: "",
      invoice_type: invoiceType,
      start_date: "",
      end_date: "",
      user_id: "1",
      testing_account_filter: "hide",
    });
    setSelectedOptions(null);
    setModal(false);
  };

  useEffect(() => {
    dispatch(getUserList({
      search_key: "",
      testing_account_filter: params.testing_account_filter || "hide",
    }));
  }, [dispatch, params.testing_account_filter]);

  useEffect(() => {
    if (params.user_id && userList?.users) {
      const user = userList.users.find(
        (user) => user.id === Number(params.user_id)
      );
      if (user) {
        setSelectedOptions({
          value: user.id,
          label: user.company_name,
        });
      }
    }
  }, [userList, params.user_id]);
  return (
    <Modal
      className="filter-modal"
      isOpen={modal}
      toggle={() => setModal((state) => !state)}
      centered
    >
      <ModalHeader toggle={() => setModal((state) => !state)}>
        Filter Options
      </ModalHeader>

      <ModalBody>
        <div className="row">
          {/* <div className="col-md-6 form-group">
            <label>Company</label>
            <ReactSelect
              value={selectedOptions}
              onChange={handleChange}
              options={proOptions}
              placeholder="Select Company"
            />
          </div> */}

          {location.pathname === "/invoices" && (
            <div className="col-md-6 form-group">
              <label>Invoice-Type</label>
              <select
                className="form-control"
                name="invoice_type"
                value={params.invoice_type}
                onChange={handleInputChange}
              >
                <option value="">Select Service</option>
                <option value="0">Simplified</option>
                <option value="1">VAT</option>
                <option value="2">Purchase</option>
              </select>
            </div>
          )}

          <div className="col-md-6 form-group">
            <label>Start-Date</label>
            <input
              type="date"
              className="form-control w-100"
              name="start_date"
              value={params.start_date}
              onChange={handleInputChange}
            />
          </div>

          <div className="col-md-6 form-group">
            <label>End-Date</label>
            <input
              type="date"
              className="form-control w-100"
              name="end_date"
              value={params.end_date}
              onChange={handleInputChange}
              min={params.start_date}
            />
          </div>
          <TestingAccountFilter
            className="col-md-6 form-group"
            value={params.testing_account_filter || "hide"}
            onChange={handleInputChange}
          />
        </div>
      </ModalBody>

      <ModalFooter className="justify-content-center">
        <button className="buttons border-button" onClick={handleClearFilters}>
          <span>Clear Filters</span>
        </button>
        <button
          className="buttons background-button"
          onClick={handleApplyFilter}
        >
          <span>Apply Filter</span>
        </button>
      </ModalFooter>
    </Modal>
  );
}
